import {
  buildProdForCart,
  fetchCurrentSalesOrder,
  getDecryptID,
  getRandomInt,
  isEmptyObject,
  loadSaleOrderJson,
  loadSellAttributeLoading
} from '.'
import {
  DEFAULT_SALES_TAX_ID,
  SALE_PRICEBOOKS,
  SALE_PROMOTIONS,
  SELLATTRIBUTES,
  SELLATTRIBUTESGROUPS
} from '../../constants/ActionTypes'
import { DefaultSalesTax, TaxExclusive } from '../../constants/GeneralSetting'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES,
  PRODUCT_NAME_INDEX
} from '../../constants/IndexDBData'
import {
  PROD_DEFAULT_TAX,
  SALE_DEFAULT_NO_TAX
} from '../../constants/StoreSetting'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from './IndexDBActions'
import moment from 'moment'

// #region

// NOTE:
// ** CALL TO manageIndexedCartJson AND SALES INDEX DB FLOW **

// 1 - product entry for cart salesOrderMethod log to index --> regardless of internet
// 2 - when the sale is going to park --> regardless of internet
// 3 - when the payment calculator run and changes the sale JSOn --> regardless of internet
// 4 - when sending note from cart details & park sale --> regardless of internet
// 5 - directly change the sale obj in index db when the amount is all done, isAllPaid true --> regardless of internet
// 6 - log payment body to another table 'sales_pay' with the same primary key 'indexKey' --> only when internet is down

// 7 - log complete button click statusChange API's body to exisiting sale object in sales table of indexdb --> /n
// NOTE(for point 7): API will not call when internet is down but update the index anyway..!!

// 8 - when clearing the sale by calling clearAllSale fn then removing rows from sales table of index db by checking these below condition
// obj.inProgress == true &&
// obj.isCompleted == false &&
// obj.isParked == false &&
// obj.isAllPaid == paid

// PAGE REFRESH NOTE:
// 9 - keeping the record of indexKey in localhost and whenever refresh the page retrieve the last stored sale json
// 10 - updated the customer in 'SalesOrderMethod' to keep record later on to retrieve --> regardless of internet
// 11 - posted the payment in sale index db row to reload when retrieveing sale from 'SellPaymentCalculator' --> regardless of internet

// ****   ***   ***
// ** API CALL FLOW **

// 1 - if the pay click api works and returns salesOrderID, found in orderGuidID && internet online then pay and status completion api will work
// 2 - for the calling of other two API will have must check of isOnline && storage's orderGuidID
// 3 - if the above 2 checks doesnt fulfill then store the sale in indexDB only then sync after

// ****   ***   ***
// ** ALL PAID DIRECT COMPLETE SCREEN FLOW **

// 1 - when all amount is paid, keep the bit true in indexdb of isAllPaid
// 2 - then if the page is refresh on the complete button screen then it will load the current sale from index db
// 3 - and after running of each and every method which will fill up the redux according of the sale
// 4 - then out of clusterCalculations function check if the sale was all paid then set 1 in redux of is_all_paid
// 5 - catch this redux on MainSell screen and check if its 1 then must set this to 0 and calculate receipt data
// 6 - turn on the complete button screen

// ****   ***   ***
// ** PARK SALE SYNCING FLOW **

// 1 - When the sale is parked offline, it will continue to complete offline and when completed it will be synced to the server
// 2 - When the sale is parked online, and then system goes offline then it will be completed offline even if the system comes back online, and when completed it will be synced to the server
// 3 - Regardless of online or offline if any operation performed on parked sale in offline mode then it will sync after the completion of sale
// 4 - Five things to be handled for this :
//      1: if the sale parked online & then something performed while system is offline then upon system returns to online, the park sale should be picked up from indexDB
//      2: same condition apply for sale history as point 1
//      3: system comes back online but park sale is going through offline mode then payment buttons should be there for only cash
//      4: occupied attributes like floor, tables should be updated for parked sale occupied attributes from index db when the system is online
//      5: remove from retrieve from server after completing of online parked sale in offline mode, meanwhile it will go to sync on server

// #endregion

export function manageIndexedCartJson (
  cartJSON,
  inProgress,
  isCompleted,
  isParked,
  callFrom,
  parkHelper // NOTE: send is online in param only while parking sale
) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(e => {
      let existIndexJSON = {}
      let systemIsOnline = false
      if (e && e.length > 0) {
        if (e.filter(er => er.indexKey == cartJSON.indexKey).length > 0) {
          existIndexJSON = e.filter(er => er.indexKey == cartJSON.indexKey)[0]
          // check for park sale syncing helper
          if (parkHelper && !isEmptyObject(parkHelper)) {
            systemIsOnline = parkHelper.isOnline
            existIndexJSON.createBody = parkHelper.create_body // NOTE: IsOnline is using with createBody object setting
            existIndexJSON.createBody.datetime = moment().format()
            existIndexJSON.receiptCode = `${cartJSON.indexKey}`
            // existIndexJSON.datetime = moment().format()
          }
        }
      }
      manageSaleIndexed(
        existIndexJSON,
        cartJSON,
        inProgress,
        isCompleted,
        isParked,
        systemIsOnline, // NOTE: send is online in param only while parking sale
        `${callFrom}`
      )
    })
    .catch(e => {
      console.log('INDEX_DB -> manageIndexedCartJson -->', e)
    })
}

function manageSaleIndexed (
  existIndexJSON,
  cartJSON,
  inProgress,
  isCompleted,
  isParked,
  isOnline, // NOTE: send is online in param only while parking sale
  callFrom
) {
  const saleArray = []
  let counted = 1
  let isOffline = false
  if (isParked) isOffline = isOnline ? false : true
  let synced = false
  let progress = inProgress ? true : false
  let completed = isCompleted ? true : false
  let parked = isParked ? true : false
  let paid = cartJSON.isAllPaid ? true : false
  let syncInProgress = false
  let isSyncError = false
  let returnResp = {}
  let datetime = ''
  let receipt_no = cartJSON.receiptCode ? cartJSON.receiptCode : ''

  let createBody = {}
  let payBodys = []
  let completeBody = {}
  // let createBodyError = ''
  // let payBodysError = []
  // let completeBodyError = ''
  let printData = {}

  let customer =
    cartJSON.customer && cartJSON.customer.length > 0 ? cartJSON.customer : []
  let payments =
    cartJSON.payments && cartJSON.payments.length > 0 ? cartJSON.payments : []
  if (existIndexJSON && !isEmptyObject(existIndexJSON)) {
    // Check if synced
    if (existIndexJSON.isSynced) {
      synced = true
    }
    // Check if db sync is in progress
    if (existIndexJSON.syncInProgress) {
      syncInProgress = true
    }
    // Check if db sync is sent error back
    if (existIndexJSON.isSyncError) {
      isSyncError = true
    }
    // Check if in progress
    if (existIndexJSON.inProgress) {
      progress = true
    }
    if (inProgress) {
      progress = true
    }
    // Check if completed
    if (existIndexJSON.isCompleted) {
      completed = true
    }
    // date if sale completed
    if (existIndexJSON.datetime) {
      datetime = existIndexJSON.datetime
    }
    if (isCompleted) {
      completed = true
    }
    // Check if parked
    if (existIndexJSON.isParked && !isParked) {
      parked = true
    }
    if (isParked) {
      parked = true
    }
    // Check if paid
    if (existIndexJSON.isAllPaid) {
      paid = true
    }

    // Check if offline
    if (existIndexJSON.isOffline) {
      isOffline = true
    }

    // for create, pay & complete status api's body and their respective errors --> only those which are not posted on server
    if (
      existIndexJSON.createBody &&
      !isEmptyObject(existIndexJSON.createBody)
    ) {
      createBody = existIndexJSON.createBody
    }

    if (existIndexJSON.payBodys && existIndexJSON.payBodys.length > 0) {
      payBodys = existIndexJSON.payBodys
    }

    if (
      existIndexJSON.completeBody &&
      !isEmptyObject(existIndexJSON.completeBody)
    ) {
      completeBody = existIndexJSON.completeBody
    }

    // if (existIndexJSON.createBodyError) {
    //   createBodyError = existIndexJSON.createBodyError
    // }
    // if (
    //   existIndexJSON.payBodysError &&
    //   existIndexJSON.payBodysError.length > 0
    // ) {
    //   payBodysError = existIndexJSON.payBodysError
    // }
    // if (existIndexJSON.completeBodyError) {
    //   completeBodyError = existIndexJSON.completeBodyError
    // }
    if (
      existIndexJSON.returnResp &&
      !isEmptyObject(existIndexJSON.returnResp)
    ) {
      returnResp = existIndexJSON.returnResp
    }

    if (existIndexJSON.tryCount) {
      counted = existIndexJSON.tryCount
    }

    // data for print receipt
    if (existIndexJSON.printData && !isEmptyObject(existIndexJSON.printData)) {
      printData = existIndexJSON.printData
    }

    // receipt No
    if (receipt_no == '' && existIndexJSON.receiptCode) {
      receipt_no = existIndexJSON.receiptCode
    }

    // for customer
    if (
      customer.length == 0 &&
      existIndexJSON.customer &&
      existIndexJSON.customer.length > 0
    ) {
      customer = existIndexJSON.customer
    }

    // for payments
    if (
      payments.length == 0 &&
      existIndexJSON.payments &&
      existIndexJSON.payments.length > 0
    ) {
      payments = existIndexJSON.payments
    }
  }

  const saleJSON = {
    indexKey: cartJSON.indexKey,
    tryCount: counted,
    isSynced: synced, // when data is synced on server
    inProgress: progress, // sale is in progress
    isCompleted: completed, // sale has been done successfully
    isParked: parked, // sale is parked
    isAllPaid: paid, // all payments for the sale has been done
    isOffline: isOffline, // if sale is offline
    syncInProgress: syncInProgress, // if db syncing is in progress
    isSyncError: isSyncError, // if db syncing sent back error
    returnResp: returnResp, // return api whole response
    datetime: datetime, // records the date of completion of sale

    createBody: createBody,
    payBodys: payBodys,
    completeBody: completeBody,
    // createBodyError: createBodyError,
    // payBodysError: payBodysError,
    // completeBodyError: completeBodyError,

    printData: printData,

    behaviorName: cartJSON.BehaviorName, // 3 for Update case , 1 for New Sales
    e_SalesOrderID: cartJSON.E_SalesOrderID,
    receiptCode: receipt_no,
    e_OutletID: cartJSON.E_OutletID,
    e_RegisterID: cartJSON.E_RegisterID,
    e_CustomerID: cartJSON.E_CustomerID,
    saleChannelID: cartJSON.SaleChannelID,
    notes: cartJSON.Notes,
    salesOrderDiscountPrice: cartJSON.SalesOrderDiscountPrice,
    totalDiscount: cartJSON.TotalDiscount,
    discountIsPercentage: cartJSON.DiscountIsPercentage,
    discountPercentage: cartJSON.DiscountPercentage,
    e_ParentSalesOrderID: cartJSON.E_ParentSalesOrderID,
    e_SalesOrderStatusID: cartJSON.E_SalesOrderStatusID, //on that time ye parked hoga
    totalPrice: cartJSON.TotalPrice,
    totalPriceExc: cartJSON.TotalPriceExc,
    totalSupplyPrice: cartJSON.TotalSupplyPrice,
    totalTax: cartJSON.TotalTax,
    monitoringComment: cartJSON.MonitoringComment,
    products: cartJSON.Products.map(q => {
      return {
        behaviorName: q.BehaviorName,
        e_SalesOrderItemID: q.E_SalesOrderItemID,
        e_SalesOrderID: q.E_SalesOrderID,
        e_ProductID: q.E_ProductID,
        sSalesOrderID: q.E_SalesOrderID,
        sSalesOrderItemID: q.E_SalesOrderItemID,
        sProductID: q.E_ProductID,
        orderTrackingID: q.orderTrackingID,
        productName: q.ProductName,
        isRowDataPoke: q.IsRowDataPoke,
        isRemoveProduct: q.IsRemoveProduct,
        isPriceAdjusted: q.IsPriceAdjusted,
        quantity: q.Quantity,
        unitPrice: q.UnitPrice,
        basePrice: q.BasePrice,
        baseTax: q.BaseTax,
        loyaltyValue: q.LoyaltyValue,
        totalPrice: q.TotalPrice,
        totalTax: q.TotalTax,
        totalTaxWithoutFix: q.TotalTaxWithoutFix,
        e_Tax_id: q.E_Tax_id,
        productNote: q.ProductNote,
        discountIsPercentage: q.DiscountIsPercentage,
        salesItemDiscountPercent: q.salesItemDiscountPercent,
        markupPercentage: q.MarkupPercentage,
        salesItemDiscount: q.SalesItemDiscount,
        currentInventory: q.currentInventory,
        isProductInventory: q.isProductInventory,
        supplyPrice: q.supplyPrice,
        isRefund: q.isRefund,
        isOnAccount: q.isOnAccount,
        key: q.key,
        variantName: q.VariantName,
        priceBooks: q.PriceBooks.map(t => {
          return {
            e_PriceBookID: t.E_PriceBookID,
            priceBookName: t.PriceBookName,
            unitPrice: t.UnitPrice
          }
        }),
        promotions: q.Promotions.map(r => {
          return {
            promoJSON: r.PromoJSON,
            e_PromotionID: r.E_PromotionID,
            promotionValue: r.PromotionValue,
            promotionName: r.PromotionName,
            promoCodes: r.PromoCodes
          }
        }),
        taxComponents: q.TaxComponents.map(z => {
          return {
            e_SalesOrderItemTaxID: z.E_SalesOrderItemTaxID, // E_salesOrderItemTaxID, e_salesOrderItemTaxID
            e_SalesOrderID: z.E_SalesOrderID, // E_salesOrderID, e_SalesOrderID
            e_SalesOrderItemID: z.E_SalesOrderItemID, // E_SalesOrderItemID, e_salesOrderItemID
            e_TaxId: z.E_TaxId,
            taxName: z.TaxName,
            taxRate: z.TaxRate,
            total_tax: z.Total_tax,
            base_tax: z.Base_tax,
            isApplied: z.IsApplied,
            isFix: z.isFix,
            taxId: z.E_TaxId,
            indexKey: z.indexKey ? z.indexKey : '',
            taxCode: z.taxCode ? z.taxCode : ''
          }
        }),

        // replicas
        displayQuantity: q.Quantity,
        displayPrice: q.displayPrice_index,

        indexKey: q.indexKey ? q.indexKey : '',
        userID: q.userID ? q.userID : 0
      }
    }),
    finals: cartJSON.finals,
    amountToPay: cartJSON.AmountToPay,
    balance: cartJSON.Balance,
    change: cartJSON.Change,
    totalSavings: cartJSON.TotalSavings,
    totalTaxComponent: cartJSON.totalTaxComponent,
    isRefund: cartJSON.isRefund,
    totalRefundItems: cartJSON.TotalRefundItems,
    //this is extra -> because in prod json build fn there are var check starting with small letters
    productsReplica: cartJSON.productsReplica,
    totalItems: cartJSON.totalItems,
    isAccountRefund: cartJSON.isAccountRefund,

    // 2nd point
    amountToPay: cartJSON.AmountToPay,
    balance: cartJSON.Balance,
    change: cartJSON.Change,

    // 3rd & 4th point
    notes: cartJSON.Notes,

    // 5th point
    deletedProds: cartJSON.DeletedProds ? cartJSON.DeletedProds : [],
    cashRegPaymentID: cartJSON.CashRegPaymentID
      ? cartJSON.CashRegPaymentID
      : '',

    // 6th point for attributes
    // SellAttributes: cartJSON.SellAttributes ? cartJSON.SellAttributes : [],

    // 7th point
    customer: customer,

    // 8th point
    payments: payments,

    // 9th current custom date for operations, like ordering of parking sales etc
    operateDateTime: moment().format(),

    // 10th for sell selected attributes
    sellAttributes: cartJSON.attribProps
  }

  // posting to index db
  saleArray.push(saleJSON)
  saveEntitiesDatatoIndexBD(
    saleArray,
    INDEX_DB_NAME,
    CURRENT_VERSION,
    INDEX_DB_TABLES.SALES,
    `${callFrom} --> manageSaleIndexed`
  )
  console.log(
    'CURR_KEY_INDEX',
    cartJSON.indexKey ? cartJSON.indexKey : undefined
  )
}

export const fetchInfoForProdJson = (
  prod,
  outID,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  user
) => {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.STORECONFIGURATIONS
  )
  data
    .then(e => {
      let isExc = true
      let generalSaleTaxID = 0
      if (e && e.length > 0) {
        isExc =
          e.filter(q => q.key == TaxExclusive).length > 0 &&
          e.filter(q => q.key == TaxExclusive)[0].value.toLowerCase() == 'true'
            ? true
            : false
        generalSaleTaxID =
          e.filter(q => q.key == DefaultSalesTax).length > 0
            ? e.filter(q => q.key == DefaultSalesTax)[0].value
            : 0
      }
      indexOutletInfo(
        prod,
        outID,
        dispatch,
        body,
        prevValue,
        selectedProds,
        outInvWarn,
        isExc,
        generalSaleTaxID,
        user
      )
    })
    .catch(e => {
      console.log(
        'INDEX_DB -> fetchInfoForProdJson, index api call STORECONFIGURATIONS -->',
        e
      )
    })
}

function indexOutletInfo (
  prod,
  outID,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  isExc,
  generalSaleTaxID,
  user
) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALETAXASSIGNEDOUTLET
  )
  data
    .then(e => {
      let storeOutletTax = 0
      if (e && e.length > 0) {
        storeOutletTax =
          e.filter(q => q.salesTaxAssignedOutletID == getDecryptID(outID))
            .length > 0
            ? e.filter(
                q => q.salesTaxAssignedOutletID == getDecryptID(outID)
              )[0].salesTaxID
            : 0
      }

      buildUpProdJSON(
        prod,
        dispatch,
        body,
        prevValue,
        selectedProds,
        outInvWarn,
        isExc,
        generalSaleTaxID,
        storeOutletTax,
        user
      )
    })
    .catch(e => {
      console.log(
        'INDEX_DB -> indexOutletInfo, index api call SALETAXASSIGNEDOUTLET -->',
        e
      )
    })
}

function buildUpProdJSON (
  prods,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  isExc,
  generalSaleTaxID,
  storeOutletTax,
  user
) {
  if (prods && prods.length > 0) {
    const prods_json = prodJSON_TAXE_ID(
      prods,
      isExc,
      generalSaleTaxID,
      storeOutletTax
    )

    if (prods_json && prods_json.length > 0) {
      getGroupTaxes(
        prods_json,
        dispatch,
        body,
        prevValue,
        selectedProds,
        outInvWarn,
        user
      )
    }
  }
}

function prodJSON_TAXE_ID (prods, isExc, generalSaleTaxID, storeOutletTax) {
  let prod_json = [...prods]
  prod_json.map(ww => {
    let tax_id = SALE_DEFAULT_NO_TAX
    const prodOutletTaxes =
      ww && ww.prodOutletTaxes && ww.prodOutletTaxes.length > 0
        ? ww.prodOutletTaxes
        : []

    // // NOTE: LOGIC FOR CREATING TAX REVISION JSON

    const general_tax =
      generalSaleTaxID &&
      parseInt(generalSaleTaxID) &&
      parseInt(generalSaleTaxID) > 0
        ? generalSaleTaxID
        : SALE_DEFAULT_NO_TAX

    const out_sale_tax =
      storeOutletTax && parseInt(storeOutletTax) && parseInt(storeOutletTax) > 0
        ? storeOutletTax
        : SALE_DEFAULT_NO_TAX

    tax_id = isExc ? out_sale_tax : general_tax

    const prod_outlet_tax =
      prodOutletTaxes.filter(uu => uu.productID == ww.productID) &&
      prodOutletTaxes.filter(uu => uu.productID == ww.productID).length > 0
        ? prodOutletTaxes.filter(uu => uu.productID == ww.productID)[0]
            .salesTaxID
        : false

    if (prod_outlet_tax) {
      if (prod_outlet_tax != PROD_DEFAULT_TAX) {
        tax_id = prod_outlet_tax
      }
    }

    if (tax_id && tax_id > 0) {
      tax_id = parseInt(tax_id)
    } else tax_id = SALE_DEFAULT_NO_TAX

    ww.tax_id = tax_id
  })

  return prod_json

  // let tax_id = SALE_DEFAULT_NO_TAX
  // const prodOutletTaxes =
  //   prod_json &&
  //   prod_json.prodOutletTaxes &&
  //   prod_json.prodOutletTaxes.length > 0
  //     ? prod_json.prodOutletTaxes
  //     : []

  //NOTE: LOGIC FOR CREATING TAX REVISION JSON

  // const general_tax =
  //   generalSaleTaxID &&
  //   parseInt(generalSaleTaxID) &&
  //   parseInt(generalSaleTaxID) > 0
  //     ? generalSaleTaxID
  //     : SALE_DEFAULT_NO_TAX

  // const out_sale_tax =
  //   storeOutletTax && parseInt(storeOutletTax) && parseInt(storeOutletTax) > 0
  //     ? storeOutletTax
  //     : SALE_DEFAULT_NO_TAX

  // tax_id = isExc ? out_sale_tax : general_tax

  // const prod_outlet_tax =
  //   prodOutletTaxes.filter(uu => uu.productID == prod_json.productID) &&
  //   prodOutletTaxes.filter(uu => uu.productID == prod_json.productID).length > 0
  //     ? prodOutletTaxes.filter(uu => uu.productID == prod_json.productID)[0]
  //         .salesTaxID
  //     : false

  // if (prod_outlet_tax) {
  //   if (prod_outlet_tax != PROD_DEFAULT_TAX) {
  //     tax_id = prod_outlet_tax
  //   }
  // }

  // if (tax_id && tax_id > 0) {
  //   tax_id = parseInt(tax_id)
  // } else tax_id = SALE_DEFAULT_NO_TAX

  // return tax_id
}

function getGroupTaxes (
  prods_json,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  user
) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALESTAXGROUPS
  )
  data
    .then(e => {
      prodJSON_TAXES(
        prods_json,
        dispatch,
        body,
        prevValue,
        selectedProds,
        outInvWarn,
        e,
        user
      )
    })
    .catch(e => {
      console.log(
        'INDEX_DB_ERROR -> getGroupTaxes, index api call SALESTAXGROUPS -->',
        e
      )
    })
}

function prodJSON_TAXES (
  prods_all,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  grpTaxes,
  user
) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALESTAXES
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        let prods = [...prods_all]
        let all_saleTaxes = e.filter(q =>
          prods.some(prod => prod.tax_id == q.salesTaxID)
        )

        if (all_saleTaxes) {
          prods.map(prod_json => {
            const saleTaxes =
              all_saleTaxes.filter(hh => hh.salesTaxID == prod_json.tax_id)
                .length > 0
                ? all_saleTaxes.filter(
                    hh => hh.salesTaxID == prod_json.tax_id
                  )[0]
                : {}

            if (saleTaxes && !isEmptyObject(saleTaxes)) {
              if (prod_json && !isEmptyObject(prod_json)) {
                prod_json.__Tax_id = saleTaxes.salesTaxID
                prod_json.baseTax = saleTaxes.taxValue
                prod_json.taxName = saleTaxes.saleTaxName
                prod_json.tax_id = `${saleTaxes.salesTaxID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`

                if (saleTaxes.isGroup) {
                  prod_json.taxesRevisionList = buildGroupTaxes(
                    prod_json.__Tax_id,
                    e,
                    grpTaxes
                  )
                } else {
                  prod_json.taxesRevisionList = [
                    {
                      taxID: prod_json.tax_id,
                      key: saleTaxes.salesTaxID,
                      name: saleTaxes.saleTaxName,
                      value: saleTaxes.taxValue,
                      isFix: saleTaxes.isFix,
                      isGroup: saleTaxes.isGroup
                    }
                  ]
                }
              }
            }
          })

          sendJson(
            prods,
            dispatch,
            body,
            prevValue,
            selectedProds,
            outInvWarn,
            user
          )
        }
      }
    })
    .catch(e => {
      console.log(
        'INDEX_DB_ERROR -> prodJSON_TAXES, index api call SALESTAXES -->',
        e
      )
    })
}

function buildGroupTaxes (tax_id, saleTaxes, grpTaxes) {
  try {
    let taxRevList = []
    if (grpTaxes && grpTaxes.length > 0) {
      let groupTaxes =
        grpTaxes.filter(q => getDecryptID(q.parentTaxID) == tax_id).length > 0
          ? grpTaxes.filter(q => getDecryptID(q.parentTaxID) == tax_id)
          : false

      if (groupTaxes) {
        const tax_grps = saleTaxes.filter(saleTax =>
          groupTaxes.some(
            groupTax => getDecryptID(groupTax.taxID) == saleTax.saleTaxID
          )
        )
        if (tax_grps && tax_grps.length > 0) {
          tax_grps.map(tg => {
            taxRevList.push({
              taxID: `${tg.saleTaxID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
              key: tg.saleTaxID,
              name: tg.saleTaxName,
              value: tg.taxValue,
              isFix: tg.isFix,
              isGroup: tg.isGroup
            })
          })
        }
      }
    }
    return taxRevList
  } catch (ex) {
    return []
  }
}

function sendJson (
  prodsJSON,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  user
) {
  if (prodsJSON && prodsJSON.length > 0) {
    const respBody = {
      variants: prodsJSON[0].productVariantAttributes,
      products: prodsJSON,
      parentProdID: prodsJSON[0].parentProductID
        ? `${prodsJSON[0].parentProductID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
        : ''
    }
    buildProdForCart(
      respBody,
      dispatch,
      body,
      prevValue,
      selectedProds,
      outInvWarn,
      user
    )
  }
}

export const getPromoFromIndexDB = (dispatch, outID) => {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.PROMOTIONS
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        let promos =
          e.filter(q => q.outletIDs == outID || q.outletIDs == 0).length > 0
            ? e.filter(q => q.outletIDs == outID || q.outletIDs == 0)
            : false

        if (promos && promos.length > 0) {
          const now = new Date()
          const result = []
          promos.forEach(promo => {
            const promoStartHours = new Date(promo.startDate).getHours()
            const promoStartMinutes = new Date(promo.startDate).getMinutes()

            const promoEndHours = new Date(promo.endDate).getHours()
            const promoEndMinutes = new Date(promo.endDate).getMinutes()

            const currentHours = now.getHours()
            const currentMinutes = now.getMinutes()

            if (
              (promoEndHours > currentHours ||
                (promoEndHours === currentHours &&
                  promoEndMinutes >= currentMinutes)) &&
              (promoStartHours < currentHours ||
                (promoStartHours === currentHours &&
                  promoStartMinutes <= currentMinutes))
            ) {
              result.push(promo)
            }
          })

          if (result && result.length > 0) {
            dispatch({ type: SALE_PROMOTIONS, payload: result })
            // console.log('XXX-YYY-ZZZ--PROMO INDEX', JSON.stringify(result))
          }
        }
      }
    })
    .catch(e => {
      console.log(
        'INDEX_DB_ERROR -> getPromoFromIndexDB, index api call PROMOTIONS -->',
        e
      )
    })
}

export const getPriceBookFromIndexDB = (dispatch, outID) => {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.PRICEBOOKS
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        let pbs =
          e.filter(
            q =>
              getDecryptID(q.outletID) == getDecryptID(outID) ||
              getDecryptID(q.outletID) == 0
          ).length > 0
            ? e.filter(
                q =>
                  getDecryptID(q.outletID) == getDecryptID(outID) ||
                  getDecryptID(q.outletID) == 0
              )
            : false

        if (pbs && pbs.length > 0) {
          dispatch({ type: SALE_PRICEBOOKS, payload: pbs })
          console.log('XXX-YYY-ZZZ--PRICEBOOK INDEX', JSON.stringify(pbs))
        }
      }
    })
    .catch(e => {
      console.log(
        'INDEX_DB_ERROR -> getPromoFromIndexDB, index api call PROMOTIONS -->',
        e
      )
    })
}

export const loadIndexDBSellAttribGroups = dispatch => {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALEATTRIBUTEGROUPS
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        const groups = []
        e.map(da => {
          groups.push({
            groupID: da.sellAttributeGroupID
              ? `${da.sellAttributeGroupID}&&_97b6-ee62-417b-89fc-0b689f5aff80`
              : '',
            attributeID: '',
            id: da.id ? da.id : 0,
            displaySeqNo: da.displaySeqNo ? da.displaySeqNo : 0,
            saleOrderID: 0,
            title: da.title ? da.title : '',
            inProgress: false,
            amount: 0,
            sales: [],
            icon: da.icon ? da.icon : ''
          })
        })
        dispatch({ type: SELLATTRIBUTESGROUPS, payload: groups })
      }
    })
    .catch(e => {
      console.log(
        'INDEX_DB_ERROR -> loadIndexDBSellAttribGroups, index api call SALEATTRIBUTEGROUPS -->',
        e
      )
    })
}

export const loadIndexDBSellAttributes = (dispatch, body, parkedSales) => {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALEATTRIBUTES
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        const attribs = []
        let data = e
        if (body && body.GroupID) {
          data = data.filter(
            we =>
              getDecryptID(we.sellAttributeGroupID) ==
              getDecryptID(body.GroupID)
          )
        }
        data.map(da => {
          let sale_count = 0
          let sale_id = 0
          let in_progress = false
          let isOffline = false
          if (parkedSales && parkedSales.length > 0) {
            parkedSales.map(qw => {
              if (!qw.isAllPaid) {
                if (qw.sellAttributes && qw.sellAttributes.length > 0) {
                  const filtered = qw.sellAttributes.filter(
                    rr => getDecryptID(rr.attributeID) == da.sellAttributeID
                  )
                  if (filtered && filtered.length > 0) {
                    sale_count += 1
                    in_progress = true
                    sale_id = qw.e_SalesOrderID
                      ? getDecryptID(qw.e_SalesOrderID)
                      : 0
                    isOffline = qw.indexKey
                  }
                }
              }
            })
          }
          attribs.push({
            groupID: da.sellAttributeGroupID
              ? `${da.sellAttributeGroupID}&&_97b6-ee62-417b-89fc-0b689f5aff80`
              : '',
            attributeID: da.sellAttributeID
              ? `${da.sellAttributeID}&&_97b6-ee62-417b-89fc-0b689f5aff80`
              : '',
            id: da.id ? da.id : 0,
            displaySeqNo: da.displaySeqNo ? parseInt(da.displaySeqNo) : 0,
            saleOrderID: sale_id,
            title: da.title ? da.title : '',
            inProgress: in_progress,
            amount: 0,
            sales: [],
            saleCount: sale_count,
            isOffline: isOffline
          })
        })
        dispatch({ type: SELLATTRIBUTES, payload: attribs })
        dispatch(loadSellAttributeLoading(false))
      }
    })
    .catch(e => {
      console.log(
        'INDEX_DB_ERROR -> loadIndexDBSellAttribGroups, index api call SALEATTRIBUTEGROUPS -->',
        e
      )
    })
}

export const SaleIndexSellAttributes = async (
  indexKey,
  attribProps,
  dispatch,
  saleJson
) => {
  if (indexKey) {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(async e => {
        const saleExist = e.filter(er => er.indexKey == indexKey)
        if (saleExist && saleExist.length > 0) {
          let sale = saleExist[0]
          sale.sellAttributes = attribProps
          saleJson.attribProps = attribProps
          dispatch(loadSaleOrderJson(saleJson))
          await saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'SaleIndexSellAttributes'
          )
        }
      })
      .catch(e => {
        console.log('INDEX_DB -> SaleIndexSellAttributes -->', e)
      })
  }
}

export const getAllParkedIndexedSales = (dispatch, body) => {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      let sales = []
      if (e && e.length > 0) {
        const saleExist = e.filter(
          er =>
            getDecryptID(er.e_SalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('Parked')) &&
            getDecryptID(er.e_OutletID) == getDecryptID(body.OutletID)
        )
        if (saleExist && saleExist.length > 0) {
          sales = saleExist
        }
      }
      loadIndexDBSellAttributes(dispatch, body, sales)
    })
    .catch(e => {
      loadIndexDBSellAttributes(dispatch, body, [])
      console.log('INDEX_DB -> getAllParkedIndexedSales -->', e)
    })
}

export const getIndexedAttribSales = (dispatch, body) => {
  // const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  // data
  //   .then(async e => {
  //     let sales = []
  //     const saleExist = e.filter(er => er.indexKey == indexKey)
  //     if (saleExist && saleExist.length > 0) {
  //       sales = saleExist
  //     }
  //     loadIndexDBSellAttributes(dispatch, body, sales)
  //   })
  //   .catch(e => {
  //     loadIndexDBSellAttributes(dispatch, body, [])
  //     console.log('INDEX_DB -> getIndexedAttribSales -->', e)
  //   })
}
